<template>
  <div>
    <!-- <router-link :to="{ name: 'invoices.purchase.new' }" class="button is-primary">Inkoop factuur aanmaken</router-link> -->
    <div class="columns spacing-top-20">
      <div class="column is-7">
        <div class="columns">
          <div class="column is-4">
            <b-field label="Filteren">
                <b-input v-model="search"></b-input>
            </b-field>
          </div>
        </div>

        <b-table
          :data="filteredList"
          :paginated="true"
          :pagination-simple="false"
          :per-page="15"
          default-sort-direction="desc"
          default-sort="number">
          <template slot-scope="completed">
            <b-table-column field="number" width="100" label="Nr." sortable numeric>
              {{ completed.row.number }}
            </b-table-column>
            <b-table-column label="Crediteur">
              {{ completed.row.crediteur | crediteur }}
            </b-table-column>
            <b-table-column label="Datum">
              {{ completed.row.date | date('lll')}}
            </b-table-column>
            <b-table-column>
              <a v-if="completed.row.number" @click="creditNote(completed.row.id)" class="button is-danger">Crediteren</a>
            </b-table-column>
            <b-table-column>
              <a @click="show(completed.row.document)" class="button is-info" v-if="completed.row.number"><span class="icon"><i class="fa fa-info"></i></span></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="column">
        <iframe v-if="activeDocument" v-document="activeDocument"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import creditNote from '../creditNote'

export default {
  computed: {
    ...mapGetters({
      completed: 'purchasesCompleted',
      crediteuren: 'crediteuren'
    }),
    filteredList () {
      return this.completed.filter(invoice => {
        const search = this.search.toLowerCase()

        if (!search) {
          return true
        }

        // console.log(invoice)
        const crediteur = this.crediteuren.find((object) => {
          return String(object.subNr) === String(invoice.crediteur)
        })

        invoice.name = crediteur.acctName

        for (let key in invoice) {
          const value = String(invoice[key]).toLowerCase()

          if (value.includes(search)) {
            return true
          }
        }

        for (let receipt of invoice.receipts) {
          for (let key in receipt) {
            const value = String(receipt[key]).toLowerCase()

            if (value.includes(search)) {
              return true
            }
          }
        }

        return false
      })
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getCrediteuren')
      await this.$store.dispatch('getPurchasesCompleted')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de verkoop facturen.'
      })
    }
  },
  data () {
    return {
      activeDocument: '',
      search: '',
      tab: 0
    }
  },
  methods: {
    show (id) {
      this.activeDocument = id
    },
    hide () {
      this.activeDocument = ''
    },
    async creditNote (id) {
      const {receipts} = this.completed.find(function (purchase) {
        return purchase.id === id
      })

      this.$modal.open({
        parent: this,
        component: creditNote,
        props: {
          id,
          receipts,
          type: 'PURCHASE'
        }
      })

      this.hide()
    }
  },
  watch: {
    tab () {
      this.activeDocument = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoices/purchase/index.vue